import request from "./http";
import qs from 'qs'

//能源区域->查询用户单位下的所有区域
// 
export function areaFindArea(params) {
    return request({
        url: "/area/findArea",
        method: "get",
        params
 
    });
}


//能源->添加-修改能源区域
// 
export function areaSaveArea(params) {
    return request({
        url: "/area/saveArea",
        method: "post",
        headers:{
            'Content-Type':'application/json',
            'Accept':'*/*'
          },
        data:params
 
    });
}

//能源->根据区域Id获取区域信息
// 
export function getAreaByAreaId(params) {
    return request({
        url: "/building/getAreaByAreaId",
        method: "get",
        headers:{
            'Content-Type':'application/x-www-form-urlencoded',
            'Accept':'*/*'
          },
        params
 
    });
}
  

//能源->删除能源区域
// 
export function areaDeleteArea(params) {
    return request({
        url: "/area/deleteArea",
        method: "delete",
        params
    });
}


//能源->通过区域Id批量添加设备
// 
export function areaSaveDevice(params) {
    return request({
        url: "/area/saveDevice",
        method: "post",
        headers:{
            'Content-Type':'application/x-www-form-urlencoded',
            'Accept':'*/*'
          },
        params
 
    });
}
  
//能源—>通过区域id设备查询
// 
export function areaFindDevice(params) {
    return request({
        url: "/area/findDevice",
        method: "get",
        headers:{
            'Content-Type':'application/x-www-form-urlencoded',
            'Accept':'*/*'
          },
        params
 
    });
}
//能源—>通过区域id量批删除设备
// 
export function areaDeleteDevice(params) {
    return request({
        url: "/area/deleteDevice",
        method: "delete",
        params
 
    });
}